<template>
  <v-dialog v-model="add_modal" max-width="1000" persistent>
    <v-card :loading="loading">
      <v-card-title>Add Vendor</v-card-title>
      <v-card-text>
        <v-form>
          <v-row dense class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Vendor Name"
                dense
                autofocus
                v-model="form_data.v_name"
                :error-messages="form_error.v_name"
                :hide-details="!form_error.v_name"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="4" style="max-width: 31%">
              <v-autocomplete
                :items="sort_list"
                label="Type"
                dense
                v-model="form_data.v_type"
                :error-messages="form_error.v_type"
                :hide-details="!form_error.v_type"
                multiple
                :search-input.sync="vendor_type_search"
                >
                  <!-- <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{ form_data.v_type.length }} Selected
                    </span>
                  </template> -->
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">
                      {{selected_multi_values}}
                    </span>
                  </template>
                  <template v-slot:no-data>
                    <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Vendor Type Found!</span> <span @click="addVendorType" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                  </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                  dense
                  v-model="form_data.bank_id"
                  :items="bank_list"
                  item-text="bank_name"
                  item-value="bank_id"
                  label="Chart of Account"
                  :error-messages="form_error.bank_id"
                  :hide-details="!form_error.bank_id"
                >
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.bank_code }}</span>
                      </template>
                      <span>{{ item.bank_name }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="2">
              <v-autocomplete
                label="ZIP"
                dense=""
                v-model="form_data.zip"
                :error-messages="form_error.zip"
                :search-input.sync="zip_search"
                :items="zip_items"
                :hide-details="!form_error.zip"
                v-debounce:500="fetchZipCodes"
                :loading="zip_loading"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="zip_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Zip Found!</span> <span @click="addZip" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-select
                :items="state_list"
                label="State"
                dense=""
                v-model="form_data.state_id"
                @change="getCity()"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <span>{{ item.short_name }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :items="cities"
                label="City"
                dense=""
                v-model="form_data.city"
                @change="changeCity()"
                class="capitalize-first-letter"
                hide-details
                :search-input.sync="city_search"
                :menu-props="{closeOnContentClick:true}"
              >
                <template v-slot:no-data v-if="city_search">
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No City Found!</span> <span @click="addCity" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Mobile"
                dense
                v-model="form_data.mobile"
                :error-messages="form_error.mobile"
                :hide-details="!form_error.mobile"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="form_data.v_code"
                label="Short Code"
                v-mask="'XXXXXXX'"
                dense
                :error-messages="form_error.v_code"
                :hide-details="!form_error.v_code"
                class="capitalize-whole-letter"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.active"
                label="Active"
                color="success"
                hide-details
                class="mt-1"
                dense=""
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense=""
                v-model="form_data.address_line_1"
                :error-messages="form_error.address_line_1"
                :hide-details="!form_error.address_line_1"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Office"
                dense
                v-model="form_data.work_phone"
                :error-messages="form_error.work_phone"
                :hide-details="!form_error.work_phone"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-switch
                v-model="form_data.email_alert"
                label="Email Alert"
                color="success"
                hide-details
                class="mt-1"
                dense
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="6">
              <v-text-field
                label="Street Address"
                class="capitalize-first-letter"
                dense=""
                v-model="form_data.address_line_2"
                :error-messages="form_error.address_line_2"
                :hide-details="!form_error.address_line_2"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Fax"
                dense
                v-model="form_data.work_fax"
                :error-messages="form_error.work_fax"
                :hide-details="!form_error.work_fax"
                v-mask="'(###)-###-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col>
              <v-text-field
                label="License Number"
                dense
                v-model="form_data.license_number"
                :error-messages="form_error.license_number"
                :hide-details="!form_error.license_number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="6">
              <v-text-field
                label="Contact Person"
                dense
                v-model="form_data.contact_person"
                :error-messages="form_error.contact_person"
                :hide-details="!form_error.contact_person"
                class="capitalize-first-letter"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <v-col cols="2">
              <v-text-field
                label="Email"
                dense=""
                v-model="form_data.email"
                :error-messages="form_error.email"
                :hide-details="!form_error.email"
                reverse
              ></v-text-field>
            </v-col>
            <v-col>
              <v-autocomplete
                prepend-icon="mdi-at"
                :items="domain_list"
                label="Domain"
                dense=""
                v-model="form_data.email_domain"
                :error-messages="form_error.email_domain"
                :hide-details="!form_error.email_domain"
                :search-input.sync="domain_search"
                :menu-props="{closeOnContentClick:true}"
                >
                <template v-slot:no-data>
                  <div class="d-flex align-center"><span class="pl-2" style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;">No Domain Found!</span> <span @click="addDomain" class="mdi mdi-plus-circle pl-1 pr-2" style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"></span></div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense class="mb-1">
            <v-col cols="6">
                <v-textarea
                  v-model="form_data.keywords"
                  label="Keywords (comma separated)"
                  dense
                  :error-messages="form_error.keywords"
                  :hide-details="!form_error.keywords"
                  rows="1"
                ></v-textarea>
            </v-col>
            <v-col cols="1" class="less-space">
            </v-col>
            <v-col cols="2">
              <v-menu
                ref="i_start_menu"
                v-model="i_start_menu"
                :close-on-content-click="false"
                :return-value.sync="form_data.insurance_start_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.insurance_start_date"
                    label="Liability Ins. Valid Dt."
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.insurance_start_date"
                    :hide-details="!form_error.insurance_start_date"
                    placeholder=" "
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  v-model="dateFormatted"
                  @input="parseDate('insurance_start_date')"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="i_start_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.i_start_menu.save(
                        form_data.insurance_start_date
                      ); changeStartDate()
                    "
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col>
              <v-menu
                ref="i_end_menu"
                v-model="i_end_menu"
                :close-on-content-click="false"
                :return-value.sync="form_data.insurance_end_date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.insurance_end_date"
                    label="Worker's Comp Valid Dt."
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    :error-messages="form_error.insurance_end_date"
                    :hide-details="!form_error.insurance_end_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  :min="disable_dates"
                  v-model="dateFormatted"
                  @input="parseDate('insurance_end_date')"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="i_end_menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="primary"
                    @click="
                      $refs.i_end_menu.save(form_data.insurance_end_date)
                    "
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense class="mb-0">
            <v-col cols="1">
              <v-text-field
                label="Tax ID"
                dense=""
                v-model="form_data.tax_id"
                :error-messages="form_error.tax_id"
                :hide-details="!form_error.tax_id"
                v-mask="'##-########'"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex align-center" style="min-width:12%">
              <v-radio-group
                v-model="form_data.amount_type"
                row
                hide-details
                class="mt-0"
                dense=""
              >
                <v-radio
                  label="Cr"
                  value="PLUS"
                  class="ma-0 pa-0"
                ></v-radio>
                <v-radio
                  label="Dr"
                  value="MINUS"
                  class="ma-0 pa-0 pl-2"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="2" style="max-width:15%">
              <v-text-field
                label="Opening Balance"
                dense
                type="number"
                v-model="form_data.opening_balance"
                :error-messages="form_error.opening_balance"
                :hide-details="!form_error.opening_balance"
                prepend-inner-icon="mdi-currency-usd"
                :color="(form_data.amount_type == 'MINUS')?'red':'green'"
                :class="(form_data.amount_type == 'MINUS')?'red-font-color':'green-font-color'"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="2" style="max-width:15%">
              <v-menu
                v-model="date_of_opening_balance"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form_data.date_of_opening_balance"
                    label="Date of Opening Balance"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    placeholder=" "
                   :error-messages="form_error.date_of_opening_balance"
                   :hide-details="!form_error.date_of_opening_balance"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted2"
                  @input="date_of_opening_balance = false; parseDate2()"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1" class="less-space"></v-col>
            <!-- <v-col cols="2">
              <v-btn block small class="primary text-capitalize">Ledger Balance: $123456.00</v-btn>
              <v-card 
                class="pa-0 ma-0"
                rounded="0"
                flat>
                  <v-card-subtitle class="custome-label-font pa-0 ma-0 pl-1">
                    Ledger Balance
                  </v-card-subtitle>
                  <v-card-text class="primary text-center white--text custome-value-font pa-0 ma-0 pt-1 pb-1 pl-1">
                    <p class="mb-3"></p>
                  </v-card-text>
                </v-card>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn  color="primary" @click="saveVendor()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "../../plugins/axios";
import { FLORIDA_STATE } from '../../plugins/global_names';
import { mapState,mapMutations } from "vuex";
export default {
  name: "VendorAdd",
  data() {
    return {
      loading: false,
      i_start_menu: false,
      i_end_menu: false,
      form_data: {
        active: true,
        email_alert: false,
        state_id : FLORIDA_STATE
      },
      bank_list: [],
      city_search: null,
      date_of_opening_balance: false,
      form_error: {},
      state_list: [],
      vendor_type_list: [],
      cities: [],
      domain_list: [],
      zip_search: null,
      zip_loading: false,
      domain_search: null,
      vendor_type_search: null,
      zip_items: [],
      disable_dates: null,
      new_zip_id: null,
      dateFormatted:null,
      dateFormatted2:null,
    };
  },
  computed: {
    ...mapState("vendor", ["add_modal"]),
    sort_list() {
      let selected_vendors = this.form_data.v_type;
      let vendors = this.vendor_type_list.filter((item) => {
        if(selected_vendors) {
          if(!selected_vendors.includes(item.value)) {
            return item
          }
        } else {
          return item
        }
      })
      vendors = vendors.sort((a,b) => {
        let fa = a.text, fb = b.text;
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
      this.vendor_type_list.filter((item) => {
        if(selected_vendors) {
          if(selected_vendors.includes(item.value)) {
            vendors.unshift(item);
          }
        }
      })
      return vendors
    },
    selected_multi_values() {
      let return_data = ''
      if(this.form_data.v_type.length > 0) {
        this.vendor_type_list.filter((item) => {
          if(item.value == this.form_data.v_type[0]) {
            return_data = item.text
          }
        })
        if(this.form_data.v_type.length > 1) {
          let totalVen = this.form_data.v_type.length - 1;
          return_data = return_data + ' ('+totalVen+' More)'
        }
      }
      return return_data;
    }
  },
  watch: {
    add_modal: {
      handler(val) {
        if (val) {
          this.form_data = {
            active: true,
            email_alert: false,
            state_id : FLORIDA_STATE
          }
        }
      },
    },
    "form_data.zip": {
      handler() {
        this.getStates();
      },
    }
  },
  methods: {
    ...mapMutations("vendor",['setData']),
    getBank() {
      let _self = this
      axios.get("account_list?itemsPerPage=-1&filter[account_type]=21&sortBy=bank_name")
        .then((response) => {
          _self.bank_list = response.data.data.data;
        })
        .catch(function () {
          
        });
    },
    parseDate2() {
      const [year, month, day] = this.dateFormatted2.split("-");
      this.form_data.date_of_opening_balance = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    addVendorType() {
      this.loading = true;
      let _self = this;
      axios
      .post("add_vendor_types", {vendor_type: _self.vendor_type_search})
      .then(function (res) {
        let data = res.data.data;
        _self.vendor_type_list.push({value: data.v_type_id,text: data.vendor_type});
        _self.form_data.v_type.push(data.v_type_id);
        _self.loading = false;
      })
      .catch(function (error) {
        console.log("FAILURE!!", error);
        _self.loading = false;
      });
    },
    addDomain() {
      this.loading = true;
      let _self = this;
      axios
      .post("add_domain", {domain: _self.domain_search})
      .then(function (res) {
        let data = res.data.data;
        _self.domain_list.push({value: data.domain_id,text: data.domain});
        _self.form_data.email_domain = data.domain_id
        _self.loading = false;
      })
      .catch(function (error) {
        console.log("FAILURE!!", error);
        _self.loading = false;
      });
    },
    addCity() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_city", {state_id: _self.form_data.state_id,city_name: _self.city_search})
        .then(function (res) {
          let data = res.data.data;
           _self.cities.push({value: data.value,text: data.text});
          _self.form_data.city = data.value
          _self.changeCity()
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    addZip() {
      this.loading = true;
      let _self = this;
      axios
        .post("add_zip", {zip_code: _self.zip_search})
        .then(function (res) {
          let data = res.data.data;
          _self.zip_items.push({value: data.value,text: data.text});
          _self.form_data.zip = data.value
          _self.new_zip_id = data.value
          _self.getStates();
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    changeStartDate() {
      if(this.form_data.insurance_start_date) {
        const [month, day, year] = this.form_data.insurance_start_date.split("/");
        this.disable_dates = year+'-'+month+'-'+day
      } else {
        return this.disable_dates = null;
      }
    },
    closePopup() {
      this.setData({ key: "add_modal", value: false });
    },
    saveVendor() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("add_vendor", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.setData({ key: "add_modal", value: false });
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
    getCity() {
      let _self = this;
      let city_key = this.form_data.state_id;
      axios
        .get("get_city?state_id=" + city_key)
        .then((response) => {
          if (response.data.status) {
            _self.cities = response.data.data;
          }
        })
        .catch(function () {});
    },
    changeCity() {
      if(this.form_data.zip == this.new_zip_id) {
        axios
          .post("zip_update",{state_id:this.form_data.state_id, zip_id:this.form_data.zip, city_id:this.form_data.city})
          .then(() => {

          })
          .catch(function () {});
      }

      this.zip_loading = true;
      axios
      .get("get_zip_by_city?city_id=" + this.form_data.city)
      .then((response) => {
        if (response.data.status) {
          this.zip_items = response.data.data;
        }
      })
      .catch(function () {})
      .then(() => {
        this.zip_loading = false;
      });

    },
    getStates() {
      let _self = this;
      axios
        .get("get_states?zip=" + this.form_data.zip)
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
            if (response.data.selection) {
              this.cities = response.data.selection.all_city;
              this.form_data.state_id = response.data.selection.selected_state;
              this.form_data.city = response.data.selection.selected_city;
            }
          }
        })
        .catch(function () {});
    },
    getVendorTypes() {
      let _self = this;
      axios
        .get("get_vendor_types")
        .then((response) => {
          if (response.data.status) {
            _self.vendor_type_list = response.data.data;
          }
        })
        .catch(function () {});
    },
    fetchZipCodes() {
      this.zip_loading = true;
      axios
        .get("get_zip_suggestion?zip=" + this.zip_search)
        .then((response) => {
          if (response.data.status) {
            this.zip_items = response.data.data;
          }
        })
        .catch(function () {})
        .then(() => {
          console.log("k");
          this.zip_loading = false;
        });
    },
    getEmailDomains() {
      axios.get("get_domains").then((response) => {
        if (response.data.status) {
          this.domain_list = response.data.data;
        }
      });
    },
    parseDate(key) {
      const [year, month, day] = this.dateFormatted.split("-");
      this.form_data[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },
    getInitalStates(){
      let _self = this;
      axios
        .get("get_states")
        .then((response) => {
          if (response.data.status) {
            _self.state_list = response.data.data;
          }
        })
        .catch(function () {});
    }
  },
  mounted: function () {
    this.getEmailDomains();
    //this.getStates();
    this.getVendorTypes();
    this.fetchZipCodes();
    this.getInitalStates();
    this.getCity();
    this.getBank();
  },
};
</script>

<style>
</style>